<template lang="pug">
  .webchat-config
    .form-container
      .sub-header--solid Webchat Configuration
      .form__inner-content
        .settings-container
          .header-config-container.field-label Websocket Server
            aiq-input(v-model="localWebchatConfigs.configs.SOCKET_HOST"
                      placeholder="Web socker server such as https://socket-service.{ENV}.agentiq.co/"
                      size="small")

        .settings-container
          .header-config-container.field-label Targets
            aiq-select(@change="changeTargets" v-model="localWebchatConfigs.configs.targets" multiple placeholder="Select" :reserve-keyword="false")
              aiq-option(v-for="item in defaultOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value")

        .settings-container
          .header-config-container.field-label Title
            aiq-input(v-model="localWebchatConfigsStrings.configs.webchat_title"
                      placeholder="Title content here"
                      size="small"
                      type="textarea")

        .settings-container
          .header-config-container.field-label Greeting Message
            aiq-input(v-model="localWebchatConfigsStrings.configs.welcome_message"
                      placeholder="Greeting message here"
                      size="small"
                      type="textarea")

        .settings-container
          .header-config-container
            .field-label Theme
            aiq-input(v-model="localWebchatConfigs.theme.color['base-theme-primary']"
                      placeholder="Primary color"
                      size="small")
            aiq-input(v-model="localWebchatConfigs.theme.color['base-theme-secondary']"
                      placeholder="Secondary color"
                      size="small")

        .hamburger(v-for="ingredients  in hamburger")
          .settings-container
            .header-config-container
              //- Legal Images section
              template(v-if="ingredients.key === 'images'")
                div.field-label {{ ingredients.label }}
                .sub-field(v-for="(image, index) in localWebchatConfigs.configs.hamburger.images")
                  .inline-label-box
                    label.inline-item.small-font(v-if="showLegalImagesUpload || image.url") {{ image.title }}
                    aiq-image.legal-image(:src="image.url" :key="image.url" v-if="image.url")
                  .inline-label-box
                    .upload-button(v-if="showLegalImagesUpload")
                      aiq-upload.no-margin(
                        v-model="image.url"
                        :http-request="upload()"
                        :action="uploadUrl"
                        accept="image/*"
                        :headers="headers"
                        :show-file-list="false"
                        :on-success="(res) => handleUploadSuccess(res, ['configs', 'hamburger', 'images', index, 'url'])"
                        ref="legalImageUploader")
                        aiq-button.upload-btn(size="small" :disabled="!uploadEnabled") Upload
                      aiq-button.delete-btn(
                        v-if="image.url"
                        size="small"
                        type="danger"
                        @click="cleanLegalImage(image)") Delete
                  .inline-label-box(v-if="image.url")
                    label.inline-item.small-font Visibility
                    aiq-select(
                      v-model="image.visibility"
                      multiple
                      placeholder="Select"
                      :reserve-keyword="false")
                      aiq-option(
                        v-for="opt in channelOptions"
                        :key="opt.value"
                        :label="opt.label"
                        :value="opt.value")
                  .inline-label-box(v-if="image.url")
                    label.inline-item.small-font Excluded Segments
                    aiq-select(
                      v-model="image.excluded_segments"
                      multiple
                      placeholder="Select"
                      :reserve-keyword="false")
                      aiq-option(
                        v-for="segment in segments"
                        :key="segment"
                        :label="segment"
                        :value="segment")
              //- Reorderable Menu section
              template(v-else-if="ingredients.key === 'menu'")
                .sub-header--solid {{ ingredients.label }}
                .form__inner-content
                  transition-group(name="el-fade-in" tag="div" class="menu-list")
                    .menu-item(v-for="(item, index) in localWebchatConfigs.configs.hamburger.menu" :key="item.value")
                      .top
                        label.sub-label {{ item.description }}
                        .reordering-controls
                          aiq-button(v-if="index" @click="reorderMenuItem(index, 'up')" size="small") Up
                          aiq-button(v-if="index < localWebchatConfigs.configs.hamburger.menu.length - 1" @click="reorderMenuItem(index, 'down')" size="small") Down
                      .inline-label-box(v-if="getIsMenuItemLoaded(item)")
                        label.inline-item.small-font Display Name
                        aiq-input(v-model="localWebchatConfigsStrings.configs.hamburger.menu_items[item.value].label"
                                  placeholder="Display Name"
                                  size="small")
                      .inline-label-box
                        label.inline-item.small-font Visibility
                        aiq-select(v-model="item.visibility"
                                  multiple
                                  placeholder="Select"
                                  :reserve-keyword="false"
                                  clearable
                                  :clear-icon="Icon.Close")
                          aiq-option(v-for="op in channelOptions"
                                    :key="op.value"
                                    :label="op.label"
                                    :value="op.value"
                                    :disabled="getIsDisabled(item.value, op.value)")
                      .inline-label-box
                        label.inline-item.small-font Excluded Segments
                        aiq-select(v-model="item.excluded_segments" multiple placeholder="Select" :reserve-keyword="false")
                          aiq-option(v-for="item in segments"
                                    :key="item"
                                    :label="item"
                                    :value="item")
                      template(v-if="item.type === 'workflow'")
                        .inline-label-box
                          label.inline-item.small-font Workflow Name
                          aiq-select(v-model="item.workflow" placeholder="Workflow Name")
                            aiq-option(v-for="item in workflows"
                                      :key="item"
                                      :label="item"
                                      :value="item")
                        .workflow-controls
                          aiq-button(v-if="canDeleteWorkflow" type="danger" plain @click="deleteWorkflow(item)" size="small") Delete
                          aiq-button(v-if="canAddWorkflow" type="success" plain @click="addWorkflow(item)" size="small") Add
                      .inline-label-box
                        label.inline-item.small-font Icon
                        .hamburger-icon-container
                          aiq-image.hamburger-icon(:src="item.icon" :key="item.icon" v-if="item.icon")
                          .controls
                            aiq-upload.no-margin(
                              v-model="item.icon"
                              :http-request="upload()"
                              :action="uploadUrl"
                              accept="image/jpg, image/jpeg, image/png, image/gif"
                              :headers="headers"
                              :show-file-list="false"
                              :before-upload="(file) => onHandleBeforeUpload(file, 'hamburgerIcon')"
                              :on-success="(res) => handleUploadSuccess(res, ['configs', 'hamburger', 'menu', index, 'icon'])"
                              ref="menuIconUploader")
                              aiq-button.upload-btn(size="small" :disabled="!uploadEnabled") Upload
                            aiq-button.delete-btn(
                              v-if="item.icon"
                              size="small"
                              type="danger"
                              @click="cleanMenuIcon(item)") Delete

        .settings-container
          .header-config-container
            .field-label Chat Icon
            label.sub-label.small-font {{ chatIconDescription }}
            .sub-field(v-for="(item, key) in localWebchatConfigs.theme.bubble")
              label.sub-label.small-font {{ $filters.toUpperFirst(item.label || key) }}
              .image-set(v-if="key !== 'location'")
                .inline-label-box
                  label.inline-item.small-font Background Color
                  aiq-input(v-model="item.background_color" placeholder="RGB/Hex Color" size="small")
                .inline-label-box
                  label.inline-item.small-font Image
                  .upload-button
                    aiq-upload.no-margin(v-model="item.image_url"
                                :http-request="upload()"
                                :action="uploadUrl"
                                accept="image/*"
                                :headers="headers"
                                :show-file-list="false"
                                :before-upload="(file) => onHandleBeforeUpload(file, 'chatIcon')"
                                :disabled="!uploadEnabled"
                                :on-success="(res) => handleUploadSuccess(res, ['theme', 'bubble', key, 'image_url'])"
                                ref="chatIconUploader")
                      aiq-button(size="small" :disabled="!uploadEnabled") Select File
                    aiq-input.image_url(v-model="item.image_url" placeholder="Select File" size="small" disabled)
                      template(v-if="item.image_url" v-slot:append)
                        aiq-button(class="p-0" @click="cleanBubbleImage(key)")
                          i.el-icon-close
                .inline-label-box(v-if="item.image_url")
                  aiq-image.image.chat-toggle-icon(:src="item.image_url" :key="item.image_url")
              .non-image-set(v-else)
                //- Currently it has only location
                aiq-select(v-model="localWebchatConfigs.theme.bubble[key]")
                  aiq-option(v-for="location in locationOptionsForWebchat"
                             :key="location"
                             :value="location"
                             :label="$filters.toUpperFirst(location)")

        .settings-container
          .header-config-container
            .field-label Feature Configuration
            .sub-field
              label {{ $t('settings_tab.channels_tab.webchat_configuration.feature_configuration.show_image_upload') }}
              .inline-label-box
                label.inline-item.small-font Enabled
                aiq-switch(v-model="localWebchatConfigs.features.IMAGE_UPLOAD"
                           style="--aiq-switch-on-color: #30C28B; --aiq-switch-off-color: #C0CCDA")

            .sub-field
              label {{ $t('settings_tab.channels_tab.webchat_configuration.feature_configuration.show_close_icon') }}
                aiq-tooltip(placement="top")
                  template(v-slot:content)
                    div {{ $t('settings_tab.channels_tab.webchat_configuration.feature_configuration.show_close_icon_tooltip') }}
                  fa-icon.question-mark(:icon="['fas', 'circle-question']")
              .inline-label-box
                label.inline-item.small-font Targets
                aiq-select(v-model="localWebchatConfigs.features.SHOW_CLOSE_BTN.visibility" multiple placeholder="Select" :reserve-keyword="false")
                  aiq-option(v-for="item in channelOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value")

            .sub-field
              label {{ $t('settings_tab.channels_tab.webchat_configuration.feature_configuration.show_minimize_icon') }}
                aiq-tooltip(placement="top")
                  template(v-slot:content)
                    div {{ $t('settings_tab.channels_tab.webchat_configuration.feature_configuration.show_minimize_icon_tooltip') }}
                  fa-icon.question-mark(:icon="['fas', 'circle-question']")
              .inline-label-box
                label.inline-item.small-font Targets
                aiq-select(v-model="localWebchatConfigs.features.SHOW_MINIMIZE_BTN.visibility" multiple placeholder="Select" :reserve-keyword="false")
                  aiq-option(v-for="item in channelOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value")

            .sub-field
              label {{ $t('settings_tab.channels_tab.webchat_configuration.feature_configuration.show_logout_button') }}
                aiq-tooltip(placement="top")
                  template(v-slot:content)
                    div {{ $t('settings_tab.channels_tab.webchat_configuration.feature_configuration.show_logout_button_tooltip') }}
                  fa-icon.question-mark(:icon="['fas', 'circle-question']")
              .inline-label-box
                label.inline-item.small-font Targets
                aiq-select(v-model="localWebchatConfigs.features.SHOW_LOGOUT_BTN.visibility" multiple placeholder="Select" :reserve-keyword="false")
                  aiq-option(v-for="item in channelOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value")
            .sub-field
              label Block Chat on Time Drift
              .inline-label-box
                label.inline-item.small-font Enabled
                aiq-switch(v-model="localWebchatConfigs.features.BLOCK_TIME_DRIFT.enabled"
                           style="--aiq-switch-on-color: #30C28B; --aiq-switch-off-color: #C0CCDA")
              .inline-label-box
                label.inline-item.small-font Acceptable Time Drift(in seconds)
                aiq-input(v-model.number="localWebchatConfigs.features.BLOCK_TIME_DRIFT.tolerable_time" placeholder="Select File" size="small")
              .inline-label-box
                label.inline-item.small-font Blocked Message
                aiq-input(v-model="localWebchatConfigsStrings.features.block_time_drift.display_message" placeholder="Message" size="small")

        .settings-container
          .settings__item
            .save-buttons__container.settings__item
              aiq-button(:disabled="isWebchatConfigChanged"
                        @click="resetWebchatConfig") Cancel
              aiq-button.save__button(type="primary"
                                      :disabled="isWebchatConfigChanged"
                                      @click="saveWebchatConfigs") Save
</template>

<script>
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import get from 'lodash/get';
import inRange from 'lodash/inRange';
import has from 'lodash/has';
import {
  HAMBURGER_MENU_SELECTION_OPTIONS,
  DISABLED_VISIBILITY_OPTIONS,
} from '@/constants/settings';
import { hosts } from '@/config/api.routes';
import { mapState } from 'vuex';
import { CHAT_ICON_RESOLUTION, HAMBURGER_ICON_RESOLUTION } from '@/constants';
import { useVuelidate } from '@vuelidate/core';

const MIN_WORFLOW_COUNT = 1;
const MAX_WORFLOW_COUNT = 5;

export default {
  name: 'webchat-config',
  setup() {
    return { v$: useVuelidate() };
  },
  props: {
    webchatConfigs: {
      type: Object,
    },
    segments: {
      type: Array,
      default: () => [],
    },
    workflows: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['save'],
  data() {
    return {
      localWebchatConfigsStrings: {
        configs: {
          webchat_title: '',
          welcome_message: '',
          hamburger: {
            menu: [],
            menu_items: {},
          },
        },
        features: {
          block_time_drift: {
            display_message: '',
          },
        },
        banner_and_interstitial_messages: {},
      },
      localWebchatConfigs: this.cloneLocalWebchatConfigs(this.webchatConfigs),
      channelOptions: cloneDeep(HAMBURGER_MENU_SELECTION_OPTIONS),
      defaultOptions: cloneDeep(HAMBURGER_MENU_SELECTION_OPTIONS),
      hamburger: [
        {
          label: 'Hamburger Menu',
          key: 'menu',
        },
        { label: 'Legal Images',
          key: 'images',
        },
      ],
      uploadUrl: `${hosts.management}files/upload`,
      uploadEnabled: true,
      headers: {
        Authorization: this.$store.getters['agent/authToken'],
      },
    };
  },
  watch: {
    webchatLanguageStrings: {
      handler(newVal) {
        this.localWebchatConfigsStrings = cloneDeep(get(newVal, 'webchat', {}));
      },
      deep: true,
    },
    webchatConfigs(newVal) {
      this.localWebchatConfigs = this.cloneLocalWebchatConfigs(newVal);
    },
  },
  computed: {
    ...mapState({
      webchatLanguageStrings: state => state.configs.language_strings,
      showInterstitialConfig: state => state.featureFlags.FEATURE_FLAGS.INTERSTITIAL_CONFIGURATION,
      showLegalImagesUpload: state => state.featureFlags.FEATURE_FLAGS.UPLOAD_LEGAL_IMAGES,
    }),

    isWebchatConfigChanged() {
      return isEqual(this.localWebchatConfigs, this.webchatConfigs) &&
          isEqual(this.localWebchatConfigsStrings, get(this.webchatLanguageStrings, 'webchat', {}));
    },

    locationOptionsForWebchat() {
      return ['left', 'right'];
    },

    chatIconDescription() {
      const { min, max } = CHAT_ICON_RESOLUTION;
      return this.$t(
        'settings_tab.channels_tab.webchat_configuration.chat_icon.description',
        {
          minWidth: min.width,
          minHeight: min.height,
          maxWidth: max.width,
          maxHeight: max.height,
        },
      );
    },
    localWorkflowCount() {
      const menuItems = get(this.localWebchatConfigs, 'configs.hamburger.menu', []);
      return menuItems.filter(i => i.type === 'workflow').length;
    },
    canAddWorkflow() {
      return this.localWorkflowCount < MAX_WORFLOW_COUNT;
    },
    canDeleteWorkflow() {
      return this.localWorkflowCount > MIN_WORFLOW_COUNT;
    },
  },
  methods: {
    resetWebchatConfig() {
      this.localWebchatConfigs = this.cloneLocalWebchatConfigs(this.webchatConfigs);
      this.localWebchatConfigsStrings = cloneDeep(get(this.webchatLanguageStrings, 'webchat', {}));
      if (this.$refs.alertMessages) {
        this.$refs.alertMessages.cleanForm();
      }
    },

    async saveWebchatConfigs() {
      if (!(await this.v$.$validate())) {
        this.$aiq.notify.error(
          this.$t('settings_tab.channels_tab.webchat_configuration.unable_save_error'),
        );
        return;
      }
      this.$emit('save', {
        config: this.localWebchatConfigs,
        configStrings: this.localWebchatConfigsStrings,
      });
    },

    changeTargets(changedItems) {
      const menu = this.localWebchatConfigs.configs.hamburger.menu;
      for (const m of menu) {
        m.visibility = m.visibility.filter(item => changedItems.includes(item));
      }

      this.channelOptions = cloneDeep(HAMBURGER_MENU_SELECTION_OPTIONS
        .filter(m => changedItems.includes(m.value)));
    },

    upload() {
      return async(data) => {
        try {
          return await this.$store.dispatch('files/uploadPublicManagementFile', { file: data.file });
        } catch (err) {
          this.onUploadFailed(get(err, 'response.data.error'));
        }
      };
    },

    async onHandleBeforeUpload(file, resolutionKey = 'chatIcon') {
      const resolutionMap = {
        chatIcon: CHAT_ICON_RESOLUTION,
        hamburgerIcon: HAMBURGER_ICON_RESOLUTION,
      };
      const resolution = resolutionMap[resolutionKey] || CHAT_ICON_RESOLUTION;
      const { min, max } = resolution;
      const objectUrl = URL.createObjectURL(file);
      let errorMsg = '';
      this.uploadEnabled = false;

      const imageSize = await new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve({ height: img.height, width: img.width });
        img.src = objectUrl;
      });

      URL.revokeObjectURL(objectUrl);

      if (
        inRange(imageSize.width, min.width, max.width + 1) &&
          inRange(imageSize.height, min.height, max.height + 1)
      ) {
        return true;
      }

      if (imageSize.width < min.width || imageSize.height < min.height) {
        errorMsg = this.$t(
          'settings_tab.channels_tab.webchat_configuration.chat_icon.error_smaller',
          {
            imgWidth: imageSize.width,
            imgHeight: imageSize.height,
            minWidth: min.width,
            minHeight: min.height,
          },
        );
      } else {
        errorMsg = this.$t(
          'settings_tab.channels_tab.webchat_configuration.chat_icon.error_larger',
          {
            imgWidth: imageSize.width,
            imgHeight: imageSize.height,
            maxWidth: max.width,
            maxHeight: max.height,
          },
        );
      }
      this.onUploadFailed(errorMsg);
      return false;
    },

    handleUploadSuccess(res, urlPath) {
      if (!res?.url) {
        return this.onUploadFailed();
      }
      set(this.localWebchatConfigs, urlPath, res.url);
      this.resetUploading();
      this.$aiq.notify.success('Successful');
    },

    onUploadFailed(errorMsg = 'Failed') {
      this.$aiq.notify.error(errorMsg);
      this.resetUploading();
      this.$refs.chatIconUploader && this.$refs.chatIconUploader.clearFiles();
      const menuUploaders = this.$refs.menuIconUploader;
      if (Array.isArray(menuUploaders)) {
        menuUploaders.filter(Boolean).forEach(uploader => uploader.clearFiles());
      } else if (menuUploaders) {
        menuUploaders.clearFiles();
      }
    },

    resetUploading() {
      this.uploadEnabled = true;
    },

    cleanBubbleImage(key) {
      this.localWebchatConfigs.theme.bubble[key].image_url = '';
    },

    cloneLocalWebchatConfigs(newConfig) {
      const newLocalWebchatConfigs = cloneDeep(newConfig);

      set(newLocalWebchatConfigs, 'theme.bubble.open.label', 'Open Chat Icon');
      set(newLocalWebchatConfigs, 'theme.bubble.close.label', 'Close Chat Icon');

      if (!newLocalWebchatConfigs.configs.hamburger.images || newLocalWebchatConfigs.configs.hamburger.images.length === 0) {
        newLocalWebchatConfigs.configs.hamburger.images = [
          {
            title: 'Image 1',
            url: '',
            value: '',
            visibility: [],
            excluded_segments: [],
            description: '',
          },
          {
            title: 'Image 2',
            url: '',
            value: '',
            visibility: [],
            excluded_segments: [],
            description: '',
          },
        ];
      }

      if (newLocalWebchatConfigs.configs.hamburger.images.length === 1) {
        newLocalWebchatConfigs.configs.hamburger.images = [
          newLocalWebchatConfigs.configs.hamburger.images[0],
          {
            title: 'Image 2',
            url: '',
            value: '',
            visibility: [],
            excluded_segments: [],
            description: '',
          },
        ];
      }

      return newLocalWebchatConfigs;
    },

    cleanLegalImage(image) {
      image.url = '';
      image.value = '';
      image.visibility = [];
      image.excluded_segments = [];
      image.description = '';
    },

    getIsDisabled(menuItem, selectOption) {
      return DISABLED_VISIBILITY_OPTIONS.some(o => o.menuItem === menuItem && o.selectOption === selectOption);
    },

    getIsMenuItemLoaded(item) {
      return has(this.localWebchatConfigsStrings, `configs.hamburger.menu_items.${item.value}`);
    },

    reorderMenuItem(index, direction) {
      const menu = this.localWebchatConfigs.configs.hamburger.menu;
      const newIndex = direction === 'up' ? index - 1 : index + 1;
      if (newIndex < 0 || newIndex >= menu.length) {
        return;
      }
      [menu[index], menu[newIndex]] = [menu[newIndex], menu[index]];
    },
    deleteWorkflow(item) {
      const menu = this.localWebchatConfigs.configs.hamburger.menu;
      const index = menu.findIndex(i => i.value === item.value);
      if (index !== -1) {
        menu.splice(index, 1);
      }
      set(
        this.localWebchatConfigsStrings,
        `configs.hamburger.menu_items.${item.value}.label`,
        item.label,
      );
    },
    addWorkflow() {
      const newNum = this.localWorkflowCount + 1;
      this.localWebchatConfigs.configs.hamburger.menu.push({
        label: `Custom Workflow ${newNum}`,
        label_local_key: `webchat.configs.hamburger.menu_items.hamburger_menu_custom_workflow_${newNum}.label`,
        value: `hamburger_menu_custom_workflow_${newNum}`,
        visibility: [],
        excluded_segments: [],
        description: `Custom Workflow ${newNum}`,
        type: 'workflow',
        workflow: '',
      });
    },
    cleanMenuIcon(item) {
      item.icon = '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/aiq-variables.scss";

// Tunables
$reorder-duration: 300ms;
$reorder-ease: cubic-bezier(0.22, 1, 0.36, 1);
$fade-duration: 280ms;
$fade-ease: cubic-bezier(0.25, 0.8, 0.25, 1);

.el-fade-in {
  &-move {
    transition: transform $reorder-duration $reorder-ease;
  }

  &-enter-from,
  &-leave-to {
    opacity: 0;
    transform: scale(0.98);
  }

  &-leave-active {
    position: absolute;
    width: 100%;
  }
}

.form-container {
  flex: 1;
  margin-bottom: 20px;

  .form__inner-content {
    background: #FFFFFF;
    border: 1px solid #E0E6ED;
    display: flex;
    flex-direction: column;
    padding: 18px;

    * {
      margin: 5px 0px;
    }

    .no-margin {
      padding-right: 10px;
      margin: 0px;
    }

    .hamburger {
      .settings-container {
        .header-config-container {
          &:has(.sub-header--solid) {
            width: 100%;
          }

          .sub-header--solid, .form__inner-content {
            margin: 0;
          }

          .sub-header--solid {
            font-size: 15px;
          }

          .menu-list {
            width: 482px;
            .menu-item {
              margin-bottom: 20px;
              border-radius: 6px;
              background: #f5f5f5;
              padding: 10px;
              will-change: transform, opacity;

              .top {
                display: flex;
                justify-content: space-between;
                align-items: center;

                .reordering-controls {
                  display: flex;
                  justify-content: flex-end;
                  gap: 10px;
                }

                label.sub-label {
                  font-weight: 500;
                }
              }

              .workflow-controls {
                display: flex;
                width: 100%;
                justify-content: space-between;

                & > button.el-button--danger {
                  color: var(--el-color-danger);
                  border-color: var(--el-color-danger);
                  margin-right: auto;
                }

                & > button.el-button--success {
                  color: var(--el-color-success);
                  border-color: var(--el-color-success);
                  margin-left: auto;
                }
              }
            }
          }
        }
      }
    }

    .settings-container {
      display: flex;

      .settings__item {
        align-self: flex-start;
        flex-grow: 1;
        min-width: 589px;
      }
    }


    .field-label {
      color: #475669;
      letter-spacing: 0;
      font-family: $aiq-font-family;
      font-size: 14px;
      font-weight: 300;
    }

    .header-config-container {
      width: 482px;
      .sub-field {
        padding-left: 14px;

        label svg.question-mark {
          margin-left: 5px;
          margin-top: 0;
          margin-bottom: 0;
          &:hover {
            color: $aiq-bgc-header;
          }
          &:focus {
            outline: none;
          }
        }
      }
    }

    .save-buttons__container {
      background-color: var(--aiq-color-white);
      bottom: 0;
      display: flex;
      justify-content: flex-end;
      left: 0;
      margin-bottom: 0px;
      padding: 5px 8px 0px 0px;
      width: calc(100% - 4px);

      * {
        margin: 0px 5px;
      }

      .save__button {
        margin-right: 0px;
      }
    }

    .image_url.el-input {
      display: inline-table;
    }
  }

}

.small-font {
  font-size: 12px;
}

.inline-label-box {
  display: flex;

  .inline-item {
    width: 150px;
  }

  .mr-10 {
    margin-right: 10px;
  }

  .hamburger-icon-container {
    width: 100%;
    display: flex;
    gap: 10px;
    align-items: flex-start;
    justify-content: space-between;

    img.hamburger-icon {
      height: 20px;
      width: auto;
    }

    div.controls {
      display: flex;
      gap: 5px;
      align-items: center;
      margin-top: 0;

      button.upload-btn {
        margin: 0;
      }
    }
  }
}

.image {
  height: 30px;
}

.pointer {
  cursor: pointer;
}

.upload-button {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.p-0.el-button {
  padding: 0;
  margin: 2px 0px;
}
.inline-label-box {
  span.text-danger {
    height: 0;
    margin-top: -5px;
    color: #F56C6C;
    font-size: 12px;
  }
  svg.question-mark {
    position: absolute;
    margin-left: 5px;
    margin-top: 4px;
    &:hover {
      color: $aiq-bgc-header;
    }
    &:focus {
      outline: none;
    }
  }
}
.d-flex-column {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
}

/* Slightly slower and smoother transition on reorder */
.el-fade-in-move {
  transition: transform 300ms cubic-bezier(0.22, 1, 0.36, 1); /* smooth ease-out curve */
}

/* Keep items visible and prevent layout collapse */
.el-fade-in-leave-active {
  position: absolute;
  width: 100%;
}

/* Optional: tweak enter/leave fade to match move speed */
.el-fade-in-enter-active,
.el-fade-in-leave-active {
  transition: opacity 280ms cubic-bezier(0.25, 0.8, 0.25, 1),
              transform 280ms cubic-bezier(0.25, 0.8, 0.25, 1);
}
.el-fade-in-enter-from,
.el-fade-in-leave-to {
  opacity: 0;
  transform: scale(0.98);
}
</style>

<style lang="scss">
.inline-label-box {
  &.is-error .el-input__inner, &.is-error .el-textarea__inner {
    border-color: #ff4949 !important;
  }
  .chat-toggle-icon{
    border-radius: 100%;
  }
}
</style>
